import {parse} from "../../_snowpack/pkg/mathjs.js";
export function assignEvaluations(workspace) {
  return [...workspace.values()].reduce((currentWorkspace, item) => traverseFromExpression(item, currentWorkspace), workspace);
}
function traverseFromExpression(workspaceItem, currentWorkspace) {
  for (const dep of workspaceItem.expression.dependencies) {
    if (currentWorkspace.has(dep)) {
      currentWorkspace = traverseFromExpression(currentWorkspace.get(dep), currentWorkspace);
    }
  }
  const dependenciesSatisfied = workspaceItem.expression.dependencies.every((name) => currentWorkspace.has(name) && currentWorkspace.get(name).evaluation !== void 0);
  if (dependenciesSatisfied) {
    const {expression} = workspaceItem;
    let evaluation;
    try {
      evaluation = parse(expression.stringified).evaluate(buildScope(currentWorkspace));
    } catch (error) {
      console.warn(error);
    }
    currentWorkspace.set(expression.identifier, {
      ...workspaceItem,
      ...evaluation !== void 0 ? {evaluation} : {}
    });
  } else {
    currentWorkspace.set(workspaceItem.expression.identifier, {
      ...workspaceItem,
      evaluation: void 0
    });
  }
  return currentWorkspace;
}
function buildScope(workspace) {
  return [...workspace.values()].filter(({evaluation}) => evaluation !== void 0).reduce((current, {evaluation, expression: {identifier}}) => Object.assign(current, {[identifier]: evaluation}), {});
}
